







import Vue from 'vue';
import Cell from './Cell.vue';
import { Icon } from '../../../basic';

export default Vue.extend({
  name: 'ExpandCell',
  components: { Cell, Icon },
  props: {
    field: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggle() {
      const parentNode = (this.$el.parentNode as HTMLElement);
      if (!parentNode || parentNode.tagName.toLowerCase() !== 'tr') {
        // tslint:disable-next-line: no-console
        console.error('ExpandCell needs to be a child of ExpendableRow');
      } else {
        parentNode.classList.toggle('expanded');
      }
    },
  },
});
